/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CmsFolder(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CmsFolder',
      'aria-hidden': true,
      focusable: false,
      width:  20 * scale,
      height: 15 * scale,
      viewBox: '0 0 20 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M16 6V3H8L6.125 1H1v13h15l3-8zM2 2h3.692l1.58 1.684.295.316H15v2H4l-2 5.333zm13.307 11H2.443l2.25-6h12.864z"}),createElement('path', {"opacity":".2","fill":"currentColor","d":"M9.125 6H15V4H7.567l-.296-.316L5.694 2H2v9.333L4 6zM11 7H4.693l-2.25 6h12.864l2.25-6z"}))
}
